import { defineNuxtRouteMiddleware } from "nuxt/app";
import { match } from "ts-pattern";
import type { RouteParams } from "vue-router";

const extractOrderingModeFromRoute = (params: RouteParams) => {
  const orderingMode = Array.isArray(params.orderingMode)
    ? params.orderingMode[0]
    : params.orderingMode;

  return orderingMode && orderingMode.length > 0 ? orderingMode : undefined;
};

export default defineNuxtRouteMiddleware((to) => {
  const orderingMode = extractOrderingModeFromRoute(to.params);

  return match(orderingMode)
    .returnType<boolean>()
    .with("delivery", () => true)
    .with("pickup", () => true)
    .with(undefined, () => true)
    .otherwise(() => false);
});
